import AccessDeniedMessage from 'components/shared/access_denied_message';
import { GlobalStateContext } from 'contexts/global_state_context';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import { useEffectSkipFirst } from 'utils/hooks';

const AuthorityStateContainer: React.FC = () => {
  const globalState = useContext(GlobalStateContext);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (globalState.statusCode === 403) {
      setIsAuthorized(false);
    } else {
      setIsAuthorized(true);
    }
  }, [globalState.statusCode]);

  useEffectSkipFirst(() => {
    setIsAuthorized(true);
  }, [location.pathname]);

  return isAuthorized ? (
    <>
      <Outlet />
    </>
  ) : (
    <AccessDeniedMessage target="該当情報" />
  );
};

export default AuthorityStateContainer;
